import { CanvasRenderingCtx } from '../rendering';
import { PhotoEditorAnnotationCanvasRenderer } from './photo-editor.decorator';
import { SquareAnnotation } from './annotation';

export class SquarePenRenderer implements PhotoEditorAnnotationCanvasRenderer<SquareAnnotation> {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    public annotation: SquareAnnotation,
  ) {}

  draw(renderingCtx: CanvasRenderingCtx): void {
    this.ctx.save();

    this.ctx.lineWidth = 2;
    this.ctx.strokeStyle = this.annotation.color;

    this.ctx.beginPath();
    this.ctx.rect(this.annotation.x, this.annotation.y, this.annotation.width, this.annotation.height);
    this.ctx.stroke();
    this.ctx.closePath();

    this.ctx.restore();
  }
}
